import React from 'react'
import { Row, Col, UncontrolledAlert, Modal, ModalHeader, ModalFooter, Button, Spinner } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import RecoveryMailForm from '../../components/Login/RecoveryMailForm'
import RecoveryPasswordForm from '../../components/Login/RecoveryPasswordForm'
// import { processError } from '../../lib/lib'
const cookies = new Cookies()

class PasswordRecovery extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            showAlert: false,
            alertMessage: '',
            isError: false,
            modal: false,
            ref: '',
            field: '',
            loading: false,
            recoverStep: 1,
            otpCode: '',
            password: '',
            id: '',
        }
        this.emailChange = this.emailChange.bind(this)
        this.otpCodeChange = this.otpCodeChange.bind(this)
        this.passwordChange = this.passwordChange.bind(this)
        this.handleEmailSubmit = this.handleEmailSubmit.bind(this)
        this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this)
    }

    emailChange(event) {
        this.setState({ email: event.target.value })
    }

    otpCodeChange(event) {
        this.setState({ otpCode: event.target.value })
    }

    passwordChange(event) {
        this.setState({ password: event.target.value })
    }

    componentWillMount() {
        const queryParams = new URLSearchParams(window.location.search)
        const ref = queryParams.get('ref')

        cookies.set('ref', ref, { path: '/' })
        this.setState({ ref })
    }

    async handleEmailSubmit(event) {
        this.setState({ loading: true })
        try {
            event.preventDefault()
            const token = cookies.get('accessToken')
            const lang = this.props.i18n.language
            const email = this.state.email
            const { id, success, message } = await api.passwordRecovery({ token, lang, email })

            if (success) {
                this.setState({ alertMessage: this.props.t("login-recovery-code-placeholder"), isError: false, recoverStep: 2, id })
            }
            if (!success) {
                this.setState({
                    isError: true,
                    alertMessage: message,
                })
            }
        } catch (e) {
            this.setState({ showAlert: true, isError: true, alertMessage: e.response ? e.response.data : 'Invalid api url' })
        }
        this.setState({ loading: false, showAlert: true })
        setTimeout(() => {
            this.setState({ showAlert: false })
        }, 5000)
    }

    async handlePasswordSubmit(event) {
        this.setState({ loading: true })
        try {
            event.preventDefault()
            const token = cookies.get('accessToken')
            const lang = this.props.i18n.language
            const { id, email, otpCode, password } = this.state
            const { success, message } = await api.passwordRecoveryNewPass({ token, lang, id, email, password, otpCode })

            if (success) {
                this.setState({ modal: true })
            }
            if (!success) {
                this.setState({
                    isError: true,
                    alertMessage: message,
                })
            }
        } catch (e) {
            this.setState({ showAlert: true, isError: true, alertMessage: e.response ? e.response.data : 'Invalid api url' })
        }
        this.setState({ loading: false, showAlert: true })
        setTimeout(() => {
            this.setState({ showAlert: false })
        }, 5000)
    }

    render() {
        const { t } = this.props
        return (
            <div className="position-relative">
                <Modal isOpen={this.state.modal} toggle={() => {
                    this.setState({ modal: false })
                    this.props.history.push('/login')
                }} className="mt-5">
                    <ModalHeader>{t('login-recovery-modal-header')}</ModalHeader>
                    <ModalFooter>
                        <Button className="custom-card-btn primary m-0 px-4 py-2" onClick={() => this.props.history.push('/login')}>{t('login-recovery-modal-ok')}</Button>
                    </ModalFooter>
                </Modal>
                <UncontrolledAlert
                    isOpen={this.state.showAlert}
                    toggle={() => this.setState({ showAlert: false })}
                    className="login-error"
                    color={this.state.isError ? 'danger' : 'success'}
                >{this.state.alertMessage}</UncontrolledAlert>
                <Row className="login-row w-100 m-0">
                    <Col xl={6} lg={12} className="login-bg">
                        <div className="main-logo"></div>
                    </Col>
                    <Col xl={6} lg={12} className="login-form px-0">
                        {
                            this.state.loading &&
                                <div className='loading-spinner'>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="lg"
                                        role="status"
                                        aria-hidden="true"
                                        className='spinner'
                                    />
                                </div>
                        }
                        {
                            !this.state.loading &&
                                <React.Fragment>
                                    {
                                        this.state.recoverStep === 1 && (
                                            <RecoveryMailForm
                                                handleSubmit={this.handleEmailSubmit}
                                                email={this.state.email}
                                                emailChange={this.emailChange}
                                            />
                                        )
                                    }
                                    {
                                        this.state.recoverStep === 2 && (
                                            <RecoveryPasswordForm
                                                handleSubmit={this.handlePasswordSubmit}
                                                otpCode={this.state.otpCode}
                                                password={this.state.password}
                                                otpCodeChange={this.otpCodeChange}
                                                passwordChange={this.passwordChange}
                                            />
                                        )
                                    }
                                </React.Fragment>
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}

PasswordRecovery.propTypes = {
    history: PropTypes.object,
    t: PropTypes.func,
    i18n: PropTypes.object,
}

export default withTranslation()(PasswordRecovery)



// WEBPACK FOOTER //
// ./src/views/Pages/PasswordRecovery.jsx